import { Check } from "lucide-react";
import { FadeUp } from "./FadeUp";
import { PRO_URL } from "../../lib/checkoutLinks";

const ITEMS = [
  { name: "AI Diet Plan", price: "₹2,999" },
  { name: "AI Workout Plan", price: "₹2,999" },
  { name: "Daily Tracker", price: "₹999" },
  { name: "Gym Workout Logger", price: "₹1,499" },
  { name: "AI Physique Check-ins", price: "₹1,999" },
  { name: "Progress Reports (PDF)", price: "₹1,499" },
  { name: "Community Feed & Recipes", price: "₹999" },
];

export const ValueStack = () => (
  <section className="py-14 md:py-20 px-6 bg-[#0A0A0B]">
    <div className="max-w-2xl mx-auto">
      <FadeUp>
        <h2 className="font-display text-4xl sm:text-5xl text-white text-center mb-3">
          WHAT YOU GET
        </h2>
        <p className="text-[#A1A1AA] text-center mb-10">Everything included when you join FORGE Pro.</p>
      </FadeUp>

      <FadeUp>
        <div data-testid="value-stack-card" className="bg-[#141416] border border-[#232326] rounded-[24px] p-8 sm:p-10">
          <div className="space-y-4 mb-8">
            {ITEMS.map((item) => (
              <div key={item.name} className="flex items-center justify-between border-b border-[#232326] pb-4 last:border-0 last:pb-0">
                <div className="flex items-center gap-3">
                  <Check size={18} className="text-[#C6FF3D]" />
                  <span className="text-white text-sm sm:text-base">{item.name}</span>
                </div>
                <span className="text-[#A1A1AA] text-sm line-through">{item.price}</span>
              </div>
            ))}
          </div>

          <div className="flex items-center justify-between mb-6">
            <span className="text-white font-semibold">Total Value</span>
            <span className="text-[#A1A1AA] line-through">₹12,993</span>
          </div>

          <div className="flex items-center justify-between bg-[#0A0A0B] border border-[#C6FF3D]/30 rounded-2xl px-6 py-4 mb-8">
            <span className="text-white font-semibold">Today</span>
            <div className="text-right">
              <span className="font-display text-2xl text-[#C6FF3D]">₹249</span>
              <span className="text-[#A1A1AA] text-xs"> first month</span>
              <p className="text-[#A1A1AA] text-[11px]">then ₹499/month</p>
            </div>
          </div>

          <a
            href={PRO_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="value-stack-cta"
            className="tap-target flex items-center justify-center w-full bg-[#C6FF3D] text-black font-semibold py-3.5 rounded-full hover:scale-[1.02] hover:shadow-[0_0_30px_rgba(198,255,61,0.5)] transition-all duration-300"
          >
            Claim This Offer
          </a>
        </div>
      </FadeUp>
    </div>
  </section>
);
